export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            <div className="inline-flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">
                <i className="ri-fire-line text-sm"></i>
                韩漫腐
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium whitespace-nowrap">
                <i className="ri-star-line text-sm"></i>
                日漫腐
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                <i className="ri-heart-line text-sm"></i>
                国漫耽美
              </span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-[2.25rem] leading-tight text-foreground-950 tracking-tight">
              腐漫画网
              <span className="block mt-1 text-primary-600">
                韩漫腐 · 韩漫耽美 · 日漫腐 · 国漫耽美
              </span>
            </h1>

            <p className="mt-3 font-heading text-base md:text-lg text-foreground-600 italic">
              好看腐漫热门推荐大全，免费全集下拉式随心看
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              腐漫画网专注为腐漫爱好者打造一站式阅读体验，收录海量韩漫腐、韩漫耽美、日漫腐与国漫耽美作品，涵盖校园、古风、奇幻、都市等多元题材。每日更新热门腐漫推荐，支持下拉式连续阅读，无需翻页，畅享沉浸式追漫乐趣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-6 text-xs md:text-sm text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-book-open-line text-accent-500"></i>
                收录 5000+ 部作品
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-time-line text-primary-500"></i>
                每日 24:00 准时更新
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-shield-check-line text-secondary-600"></i>
                绿色安全无广告干扰
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-thumb-up-line"></i>
                开始探索精选推荐
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300 text-foreground-700 rounded-full font-semibold text-sm hover:bg-background-100 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg aspect-[4/5] overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20illustration%20of%20two%20beautiful%20male%20characters%20in%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20manga%20aesthetic%2C%20flowing%20hair%2C%20delicate%20robes%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20minimal%20background%20with%20subtle%20gradient%2C%20editorial%20quality%2C%20ethereal%20and%20dreamy%20mood%2C%20no%20text%20or%20watermark&width=900&height=1125&seq=hero-main-visual&orientation=portrait"
                alt="腐漫画网主题主视觉 - 唯美插画风格角色"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}